import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer"

export default function PlasmidDesign() {

    // Click and scroll
    function handleClick(elementId) {
        const scrollElement = document.getElementById(elementId)
        scrollElement.scrollIntoView({behavior: "smooth"});
        // setTimeout(function () {
        //     scrollElement.scrollIntoView({behavior: "smooth"});
        // }, 100);
        console.log(elementId)
    }

    return (
        <div className="flex flex-col h-lvh">

            {/* Header */}
            <Navbar/>

            {/* Sidebar turns into subheader in mobile device */}
            <div className="inset-x-0 bg-white border-b px-4 sm:px-6 md:px-8 lg:hidden">
                <div className="flex items-center py-4">
                    <button type="button" className="text-gray-500 hover:text-gray-600"
                            data-hs-overlay="#description-sidebar" aria-controls="description-sidebar"
                            aria-label="Toggle navigation">
                        <span className="sr-only">Toggle Navigation</span>
                        <svg className="size-5" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd"
                                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                    </button>
                    <ol className="ms-3 flex items-center whitespace-nowrap">
                        <li className="flex items-center text-sm text-gray-800">
                            Project
                            <svg
                                className="flex-shrink-0 mx-3 overflow-visible size-2.5 text-gray-400"
                                width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M5 1L10.6869 7.16086C10.8637 7.35239 10.8637 7.64761 10.6869 7.83914L5 14"
                                      stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </li>
                        <li className="text-sm font-semibold text-gray-800 truncate">
                            Plasmid Design
                        </li>
                    </ol>
                </div>
            </div>

            {/* Main Content */}
            <div className="lg:flex grow max-w-[85rem] w-full mx-auto">

                {/* Sidebar with accordion */}
                <div id="description-sidebar"
                     className="max-h-svh hs-overlay hs-overlay-open:translate-x-0 -translate-x-full transition-all duration-300 transform hidden fixed top-0 start-0 bottom-0 z-20 w-72 sm:w-[36rem] bg-white border-e border-gray-200 pt-7 overflow-y-auto lg:static lg:block lg:translate-x-0 lg:end-auto lg:bottom-0 ">
                    <div className="px-6">
                        <div className="flex-none text-xl font-semibold px-1">
                            Plasmid Design
                        </div>
                    </div>

                    <nav className="p-6 w-full flex flex-col flex-wrap">
                        <ul className="space-y-1.5">
                            <li>
                                <div onClick={() => handleClick("Plasmid-1")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overview
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-2")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Overexpression plasmid
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-2-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Basic information
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-2-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Sequences
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-2-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Description
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-2-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Troubleshooting
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-3")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    Knock-down plasmid
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-3-1")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Basic information
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-3-2")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Sequences
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-3-3")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Description
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-3-4")}
                                     className="ml-8 cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-200 rounded-full inline-block"></span>
                                    <span>
                                        Troubleshooting
                                    </span>
                                </div>
                            </li>
                            <li>
                                <div onClick={() => handleClick("Plasmid-4")}
                                     className="cursor-pointer flex items-center gap-x-3.5 py-2 px-1 text-base text-slate-700 rounded-lg hover:bg-gradient-to-r hover:from-blue-50"
                                     href="#">
                                    <span className="h-4 w-4 min-w-4 bg-blue-400 rounded-full inline-block"></span>
                                    References
                                </div>
                            </li>

                        </ul>
                    </nav>
                </div>

                {/* Major text sections */}
                <div className="max-h-svh overflow-y-auto w-full px-4 sm:px-6 md:px-24 lg:px-32">
                    <div>
                        <div id="Plasmid-1" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overview
                        </div>
                        <div id="Plasmid-1-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div>
                                To facilitate the guanine crystallization, we aimed to increase the guanine production
                                in host cell BL21 Escherichia coli (E. coli). Two plasmids were designed for distinct
                                purposes: one to enhance guanine production and the other to suppress the guanine
                                degradation system.
                            </div>
                            <div className="mt-5">
                                pET-45b(+) was used as the plasmid backbone. For each purpose mentioned above, we
                                designed one oligonucleotide as an insertion and introduced it to the plasmid by
                                using restriction enzymes.
                            </div>
                            <div className="mt-5">
                                In the first plasmid (which will be annotated as “overexpression plasmid” from now
                                on), we delivered extra copies of genes guaA and guaB to E. coli. These genes play
                                an important role in guanosine monophosphate (GMP) pathway synthesis, which is later
                                involved in the purine nucleotide biosynthesis pathway producing guanine (1). The
                                sequence of aeBlue (a chromoprotein) was also included in the plasmid for
                                transformation evidence.
                            </div>
                            <div className="mt-5">
                                In the second plasmid (which will be annotated as “knock-down plasmid” from now on),
                                we designed a CRISPR-i knock-down system for the expression of gene guaD. guaD gene
                                encodes for the enzyme guanase, which degrades guanine to xanthine (2). CRISPR-i
                                system consisted of dCas9 protein and a single guide RNA molecule (gRNA) (3).
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Plasmid-2" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Overexpression plasmid (BBa_K5122003)
                        </div>
                        <div id="Plasmid-2-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Basic information
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Name: overexpression plasmid
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Type description: plasmid vector for overexpression of guaA and guaB genes
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Designer: Mai Nguyen
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Length: insertion - 3983 bp; inserted plasmid - 9163 bp
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Produced by: IDT
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Status: successfully produced, isolated and transformed
                            </div>
                        </div>
                        <div id="Plasmid-2-2" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Sequences
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Insertion map (excluding buffering sequences): SacI restriction site - guaA gene - guaB
                                gene - aeBlue - HindIII restriction site
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Plasmid: pET-45b(+)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Insertion was introduced with restriction sites SacI and HindIII on the plasmid backbone
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/results/results-1.png"
                                className="w-full mt-5"
                                alt=""
                            />
                        </div>
                        <div id="Plasmid-2-3" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Description
                            </div>
                            <div className="mt-5">
                                We designed an insertion to be integrated into the overexpression plasmid. The
                                insertion consists of sequences for genes guaA, guaB and aeBlue, each separated by
                                spacer sequences and individual ribosome binding sites (RBS) to ensure proper
                                expression. It has been proven that guaA and guaB belong to the same operon, so we
                                designed them together under a single promoter (4). The insertion was integrated into
                                the plasmid by two restriction sites: SacI and HindIII. The gene cassette was inserted
                                between the inducible T7 promoter and terminator on the plasmid backbone. Once inside
                                the bacterial cells, the gene expression was activated by the addition of IPTG as an
                                inducer. Hence, guaA and guaB would be overexpressed, which ideally led to the
                                overproduction of guanine. The aeBlue reporter gene serves as a visual marker to
                                confirm successful transformation and expression. This design enables significant
                                overexpression of the guaA and guaB gene products, thereby enhancing the formation
                                of guanine crystals.
                            </div>
                        </div>
                        <div id="Plasmid-2-4" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Troubleshooting
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                No blue colonies
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Problem: no blue colonies were found after the transformation
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Suggestion: there is an S-tag downstream of the aeBlue gene → the tag might have
                                interfered with the protein expression and function
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Improvement strategy: remove unnecessary tags to ensure protein structure and
                                expression the most
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Plasmid-3" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            Knock-down plasmid
                        </div>
                        <div id="Plasmid-3-1" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Basic information
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Name: knock-down plasmid
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Type description: plasmid vector with CRISPR-i system to knock down the expression of gene guaD
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Designer: Mai Nguyen
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Length: insertion - 4414 bp; inserted plasmid - 9163 bp
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Status: synthesis failed
                            </div>
                        </div>
                        <div id="Plasmid-3-2" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Sequences
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Insertion map (excluding buffering sequences): SacI restriction site - dCas gene - sgRNA
                                guaD - gRNA scaffold - HindIII restriction site
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Plasmid: pET-45b(+)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Insertion was introduced with restriction sites SacI and HindIII on the plasmid backbone
                            </div>
                            <img
                                src="https://static.igem.wiki/teams/5122/results/results-2.png"
                                className="w-full mt-5"
                                alt=""
                            />
                        </div>
                        <div id="Plasmid-3-3" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Description
                            </div>
                            <div className="mt-5">
                                We designed an insertion to be integrated into the knock-down plasmid. We decided to
                                use the CRISPR-i system to knock down gene guaD expression to prevent guanine
                                degradation. Much of our understanding of the CRISPR-i system was gained from
                                reference (3). We constructed a sequence that includes Streptococcus pyogenes dCas9
                                (5), a sgRNA and a gRNA scaffold. We believed the dCas9 and the gRNA system must be
                                expressed separately, so we designed an extra T7 regulatory module and corresponding
                                RBS. Because there was no proof of whether guaD gene belonged to an operon, we chose
                                the target of the gRNA to be inside the coding region, on the non-template strand as
                                guides from reference (3). The insertion was expected to be integrated into the plasmid
                                backbone and transformed into the host cell. IPTG would activate the expression of two
                                T7 regulatory modules, expressing dCas9 and its corresponding gRNA. The CRISPR-i
                                system would precisely bind to guaD coding region and block the RNA polymerase to
                                elongate the transcript. Hence, no complete mRNA would be expressed as a result of a
                                knock-down experiment. Reduced guaD expression would decrease guanine degradation,
                                leading to an excess of guanine, which could serve as a source for crystallization.
                            </div>
                        </div>
                        <div id="Plasmid-3-4" className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <div className="font-bold text-xl">
                                Troubleshooting
                            </div>
                            <div className="mt-5">
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Failure to synthesize the insertion
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Problem: IDT reported failure in insertion synthesis
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Suggestion: low GC contents (35.7%)
                            </div>
                            <div>
                                <span className="h-3 w-3 bg-blue-300 rounded-full inline-block mr-2"> </span>
                                Improvement strategy: apply codon optimization and introduce GC-rich spacer sequences
                                to enhance overall GC content.
                            </div>
                        </div>
                    </div>
                    <div>
                        <div id="Plasmid-4" className="text-2xl font-bold text-gray-800 sm:text-3xl mt-10">
                            References
                        </div>
                        <div className="text-lg text-gray-800 text-justify mt-6 rounded-2xl leading-relaxed">
                            <ol className="list-decimal space-y-4 pl-5">
                                <li>
                                    Lambden P, Drabble W. The gua Operon of Escherichia coli K-12: Evidence for Polarity from guaB to guaA. J Bacteriol. 1973;115(3):992-1002. doi: 10.1128/jb.115.3.992-1002.1973.
                                </li>
                                <li>
                                    Rakosky J, Beck J. Guanine degradation by Clostridium acidiurici I. J Bacteriol. 1955;69(5):563-5. doi: 10.1128/jb.69.5.563-565.1955.
                                </li>
                                <li>
                                    Hawkins JS, Wong S, Peters JM, Almeida R, Qi LS. Targeted transcriptional repression in bacteria using CRISPR interference (CRISPRi). Methods Mol Biol. 2015;1311:349-62. doi: 10.1007/978-1-4939-2687-9_23.
                                </li>
                                <li>
                                    Nijkamp H, Hann P. Genetic and biochemical studies of the guanosine 5'-monophosphate pathway in Escherichia coli. Biochim Biophys Acta. 1967;145(1):31-40. doi: 10.1016/0005-2787(67)90651-X.
                                </li>
                                <li>
                                    Qi LS, Larson MH, Gilbert LA, Doudna JA, Weissman JS, Arkin AP, et al. Repurposing CRISPR as an RNA-guided platform for sequence-specific control of gene expression. Cell. 2013;152(5):1173-83. doi: 10.1016/j.cell.2013.02.022.
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div className="h-16"></div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    )
}